
import { Voni } from '../client';
import FormData from 'form-data';

export interface Document {
  id: number;
  project_id: number;
  title: string;
  file_type?: string;
  file_size?: number;
  file_url?: string;
  content?: string;
  created_at: string;
  updated_at: string;
}

export interface DocumentCreateInput {
  project_id: number;
  title: string;
  content?: string;
}

export interface DocumentListParams {
  skip?: number;
  limit?: number;
}

export class DocumentResource {
  constructor(private client: Voni) {}

  async list(projectId: number, params?: DocumentListParams): Promise<Document[]> {
    return this.client.request<Document[]>('GET', '/documents/', { ...params, project_id: projectId });
  }

  async get(documentId: number): Promise<Document> {
    return this.client.request<Document>('GET', `/documents/${documentId}`);
  }

  async create(data: DocumentCreateInput): Promise<Document> {
    return this.client.request<Document>('POST', '/documents/', undefined, data);
  }

  async upload(projectId: number, file: Buffer, filename: string): Promise<Document> {
    const formData = new FormData();
    formData.append('file', file, { filename });
    formData.append('project_id', String(projectId));

    return this.client.request<Document>('POST', '/documents/upload', undefined, formData);
  }
}
